<template>
  <article>
    <div id="footer" class="footer-bottom">Copyright © {{ year }} Delta IT. All Rights Reserved.</div>
    <div class="privacy" v-if="!hasAgreedWithPrivacy">
      <div>
        <p>
          {{ $t("pages.wording.privacyWording1") }}
          <a target="blank" href="https://authnz-dev.deltaww.com/assets/docs/privacy.pdf">
            {{ $t("pages.wording.privacyWording2") }}
          </a>
          &nbsp;
          <el-button type="primary" class="btn-ok" size="small" @click="onAgreeWithPrivacy"> OK </el-button>
        </p>
      </div>
    </div>
  </article>
</template>

<script>
import { api } from "@/utils/api.js"

export default {
  name: "Footer",
  data() {
    return {
      year: new Date().getFullYear(),
      hasAgreedWithPrivacy: true,
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      api
        .apiHasAgreedPrivacy()
        .then((res) => {
          if (res) {
            this.hasAgreedWithPrivacy = res.data
          } else {
            this.hasAgreedWithPrivacy = false
          }
        })
        .catch((error) => {
          console.log(error)
        })
    },
    onAgreeWithPrivacy() {
      api
        .apiUpdateAgreePrivacy()
        .then((res) => {
          this.hasAgreedWithPrivacy = true
        })
        .catch((error) => {
          console.log(error)
        })
    },
  },
}
</script>

<style scoped>
.footer-bottom {
  font-size: 12px;
  color: #212121;
  text-align: center;
  line-height: 50px;
  background-color: #fafafa;
  padding-right: 1rem;
  position: fixed;
  height: 50px;
  bottom: 0px;
  left: 0px;
  right: 0px;
  overflow: hidden;
  z-index: 100;
}
@media (max-width: 1025px) {
  .footer-bottom {
    left: 0px;
  }
}
@media (min-width: 1026px) {
  .menuOpen .footer-bottom {
    left: 299px;
  }
}
@media (min-width: 768px) {
  .privacy {
    padding: 16px 0;
  }
}
.privacy {
  width: 100%;
  position: fixed;
  bottom: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.8);
  z-index: 999;
}
.privacy p {
  color: #fff !important;
  font-weight: 400;
  font-size: 16px;
  line-height: 20px;
  text-align: center;
}
</style>
